var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.show)?_c('PayPop',{attrs:{"ext":_vm.ext,"gid":_vm.gid,"sid":_vm.sid,"money":_vm.money},on:{"close":function($event){_vm.show = false},"pay-success":_vm.success}}):_vm._e(),_vm._v(" "),(_vm.paySuccess)?_c('div',{staticClass:"cp-pay-success-pop"},[_c('p',[_vm._v("支付成功")])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }